/**
 * Committee Grid Component
 * Container for corporate governance committee sections
 */
import React from 'react'
import styled from '@emotion/styled'

const GridWrapper = styled.div`
  min-height: 60vh;
  width: 1200px;
  max-width: 95%;
  border-spacing: 0;
  overflow: hidden;
  padding: 0 0 10px;
  margin: 0 auto;
  height: auto;
`

const GridInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 2rem;
  padding: 2rem;
  width: 95%;

  @media (max-width: 767px) {
    width: 100%;
    padding: 1.5rem 1rem;
  }
`

interface CommitteeGridProps {
  children: React.ReactNode
}

const CommitteeGrid: React.FC<CommitteeGridProps> = ({ children }) => {
  return (
    <GridWrapper>
      <GridInner>{children}</GridInner>
    </GridWrapper>
  )
}

export default CommitteeGrid
